define('plugin/promotion/view/PromotionIndexView',['require','lib/view/CompositeView','plugin/promotion/view/PromotionItemView'],function (require) {

    var CompositeView = require('lib/view/CompositeView');
    var PromotionItemView = require('plugin/promotion/view/PromotionItemView');

    /**
     * Promotion composite view (gift cards container)
     *
     * @class PromotionIndexView
     */
    return CompositeView.extend({

        template: '#promotion_list_view',
        childView: PromotionItemView,
        childViewContainer: '#sb_promotion_items_container',

        collectionEvents: {
            sync: 'render'
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'gift-card'
            });
        },

        _pageId: 'gift-card'

    });

});
